// import {UserTypeDict} from '../../../utils/settings';

const Reducer = (
  state = {
    invoiceProds: [],
    //company_prods: [],
    invoiceTotal: 0,
    company_id: null,
    sellProds: [],
    sellProdsTotal: 0,
    singleInvoice: null,
    buyer: {},
    transactPro: null,
    transactionOverview: null,
    transactionDetails: null,
    saleTail: [],
    mobile_sidebar: false,
    benefitsType: '',
    giftProduct: null,
    certificatetype: null,
    showOrderTab: false,
  },
  action,
) => {
  switch (action.type) {
    case 'SET_CERIFICATE_TYPE':
      return { ...state, certificatetype: action.data };
    case 'SET_INVOICE_PRODS':
      return { ...state, invoiceProds: action.data };
    case 'SET_INVOICE_TOTAL':
      return { ...state, invoiceTotal: action.data };
    case 'SET_COMPANY_ID':
      return { ...state, company_id: action.data };
    case 'SET_BUYER':
      return { ...state, buyer: action.data };
    case 'SET_MASON_SELL_PRODS':
      return { ...state, sellProds: action.data };
    case 'SET_SELL_TOTAL':
      return { ...state, sellProdsTotal: action.data };
    case 'Single_Invoice':
      return { ...state, singleInvoice: action.data };
    case 'SHOW_TRANSACTIONS':
      return { ...state, transactPro: action.data };
    case 'SET_TRANSACTION_DETAILS':
      return { ...state, transactionDetails: action.data };
    case 'SET_CRUMBS': {
      return { ...state, saleTail: action.data };
    }
    case 'PUSH_TO_CRUMB': {
      const tail = state.saleTail;
      tail.push(action.data);
      return { ...state, saleTail: tail };
    }
    case 'POP_FROM_CRUMB': {
      const tail = state.saleTail;
      tail.pop();
      return { ...state, saleTail: tail };
    }
    case 'TOGGLE_MOBILE_SIDEBAR':
      return { ...state, mobile_sidebar: !state.mobile_sidebar };
    case 'BENEFITS_TYPE_CHANGE':
      return { ...state, benefitsType: action.data };
    case 'SET_GIFT_PRODUCT':
      return { ...state, giftProduct: action.data };
    case 'SET_ORDER_TAB_TRUE':
      return { ...state, showOrderTab: true };

    default:
      return state;
  }
};

export default Reducer;
